import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {SezIIAccertamentoStoreValidators} from './validators/sez-II-accertamento.store-validators';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  providers: [
    SezIIAccertamentoStoreValidators,
  ]
})
export class SezIIAccertamentoFormModule { }
